.compare-layout {
	display: grid;
	grid-template-columns: 15px 1fr 60px 1fr 15px;
	grid-template-rows: min-content 1fr;
	grid-template-areas:
		'left-header left-header empty right-header right-header'
		'left-outline left-code diff right-code right-outline';
	width: 100%;
	overflow: hidden;
	align-items: stretch;
}

.compareHeader {
	display: flex;
	justify-content: space-between;
	gap: 1em;

	&[data-side='left'] {
		grid-area: left-header;
	}

	&[data-side='right'] {
		grid-area: right-header;
	}

	& > :first-child {
		min-width: 0;
	}

	& > :last-child {
		min-width: max-content;
	}
}

.left-outline,
.right-outline {
	position: relative;
}

.left-outline {
	grid-area: left-outline;
}

.right-outline {
	grid-area: right-outline;
}

.diff {
	grid-area: diff;
	position: relative;
	// Mimics the border of the left and right code
	margin-block: 1px;

	svg {
		width: 100%;
		height: 100%;
		position: absolute;
		inset: 0;
		pointer-events: none;
	}
}

.left-code,
.right-code {
	overflow: hidden;
	height: 100%;
	max-height: var(--max-code-height);

	// hack to prevent lags in Safari (TS-17792)
	*:not(pre),
	:after,
	:before {
		box-sizing: unset;
	}
}

.left-code {
	grid-area: left-code;
}

.right-code {
	grid-area: right-code;
}
